import { useMemo, useState } from "react";
import ComissaoService from "../../services/resource/ComissaoService";
import ComissaoCaxiasService from "../../services/resource/ComissaoCaxiasService";
import RomaneioService from "../../services/resource/romaneioService";
import AvisoMotoristaService from "../../services/resource/avisoTelemetriaService";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { Chips } from "primereact/chips";
import Button from "../../componentes/button/button";
import { Dialog } from "primereact/dialog";
import ComissoesParciaisBloqueadas from "./ComissoesParciaisBloqueadas";
import FeriadosModal from "./FeriadosModal";
import GerarComissaoDL from "./GerarComissaoDL";

export function GerarComissoes({ ano, mes, onGerado }) {
    const comissaoService = useMemo(() => new ComissaoService(), []);
    const comissaoCaxiasService = useMemo(() => new ComissaoCaxiasService(), []);
    const romaneioService = useMemo(() => new RomaneioService(), []);
    const avisoMotoristaService = useMemo(() => new AvisoMotoristaService(), []);

    // distribuidor mostrado: DL (geração completa, parcial e substituição) ou DA
    const [aba, setAba] = useState("dl");
    // a atualização da telemetria (Concept) é demorada: opcional antes de gerar o DA
    const [atualizarTelemetria, setAtualizarTelemetria] = useState(true);
    // recarrega a lista de parciais bloqueadas depois de uma geração
    const [refreshBloqueadas, setRefreshBloqueadas] = useState(0);
    const [loadingDA, setLoadingDA] = useState(false);
    const [etapaDA, setEtapaDA] = useState(null);
    const [modalConfigEmail, setModalConfigEmail] = useState(false);
    const [modalFeriados, setModalFeriados] = useState(false);
    const [destinatarios, setDestinatarios] = useState(['antonio.araujo@distribuidorayork.com.br', 'adilson.junior@distribuidorayork.com.br']);

    // -------- DA ----------
    const gerarDA = async () => {
        setLoadingDA(true);
        setEtapaDA(null);

        try {
            if (atualizarTelemetria) {
                setEtapaDA("avisos_motoristas");
                await avisoMotoristaService.atualizar({ ano, mes });
            }

            setEtapaDA("integrando_funcionarios");
            await romaneioService.integrarFuncionarios(ano, mes);

            setEtapaDA("calculando_romaneios");
            await romaneioService.calcularTotais(ano, mes);

            setEtapaDA("restaurando_ajustes");
            await romaneioService.restaurarAjustes(ano, mes);

            setEtapaDA("motoristas_da");
            await comissaoCaxiasService.gerarComissaoMotoristas({ ano, mes });

            setEtapaDA("auxiliares_da");
            await comissaoCaxiasService.gerarComissaoAuxiliares({ ano, mes });

            setEtapaDA("ok");
            toast.success("Comissões DA geradas com sucesso!");
            onGerado?.();
        } catch {
            setEtapaDA("erro");
            toast.error("Erro ao gerar comissões DA.");
        } finally {
            setLoadingDA(false);
        }
    };

    const enviarEmailDA = async () => {
        try {

            if (destinatarios.length < 1) {
                toast.warning("Nenhum e-mail foi selecionado para envio.");
                return false;
            }

            await comissaoService.enviarEmail({
                ano, mes,
                filialId: 4,
                filialNome: "YL Caxias",
                destinatarios: destinatarios
            });
            toast.success("E-mail enviado com sucesso!");
        } catch {
            toast.error("Erro ao enviar e-mail.");
        }
    };

    const stepsDA = [
        {
            id: "avisos_motoristas",
            label: "Atualizando telemetria (Concept)",
            icon: "fa fa-globe",
        },
        {
            id: "integrando_funcionarios",
            label: "Integrando funcionários aos romaneios",
            icon: "fa fa-users",
        },
        {
            id: "calculando_romaneios",
            label: "Calculando totais dos romaneios",
            icon: "fa fa-calculator",
        },
        {
            id: "restaurando_ajustes",
            label: "Restaurando ajustes dos romaneios",
            icon: "fa fa-wrench",
        },
        {
            id: "motoristas_da",
            label: "Gerando comissão dos motoristas",
            icon: "fa fa-truck",
        },
        {
            id: "auxiliares_da",
            label: "Gerando comissão dos auxiliares",
            icon: "fa fa-user",
        },
    ];

    const passosDA = stepsDA.filter(s => atualizarTelemetria || s.id !== "avisos_motoristas");

    const renderSteps = (steps, etapa) => {
        const stepIndex = steps.findIndex(s => s.id === etapa);

        return steps.map((step, i) => {
            const done = etapa === "ok" || stepIndex > i;
            const active = step.id === etapa && etapa !== "ok";
            const erro = etapa === "erro" && active;

            return (
                <div
                    key={step.id}
                    className={`flex items-center gap-3 p-3 rounded-xl border transition-all duration-200 text-xs
                        ${erro ? "bg-destructive/10 border-destructive/30"
                            : done ? "bg-success/10 border-success/30"
                                : active ? "bg-blue-50 border-blue-300"
                                    : "bg-muted border-border opacity-50"}`}
                >
                    <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0
                        ${erro ? "bg-destructive text-destructive-foreground"
                            : done ? "bg-success text-success-foreground"
                                : active ? "bg-blue-500 text-white"
                                    : "bg-muted text-muted-foreground"}`}
                    >
                        {erro
                            ? <i className="fa fa-times text-xs" />
                            : done
                                ? <i className="fa fa-check text-xs" />
                                : active
                                    ? <i className="fa fa-spinner fa-spin text-xs" />
                                    : <span className="text-xs font-medium">{i + 1}</span>
                        }
                    </div>

                    <span className="text-sm flex-1">{step.label}</span>
                </div>
            );
        });
    };

    const isBlocked = loadingDA;

    const aoGerarDL = () => {
        setRefreshBloqueadas((n) => n + 1);
        onGerado?.();
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            className="p-6"
        >
            <div>

                <div className="mb-5 inline-flex rounded-lg bg-muted p-1 text-sm font-medium">
                    {[
                        { id: "dl", label: "Distribuidor Logístico", icon: "fa fa-truck" },
                        { id: "da", label: "Distribuidor Autorizado — Caxias", icon: "fa fa-warehouse" },
                    ].map(op => (
                        <button
                            key={op.id}
                            type="button"
                            onClick={() => setAba(op.id)}
                            disabled={isBlocked}
                            className={`flex items-center gap-2 rounded-md px-4 py-1.5 transition-colors duration-150 ${aba === op.id
                                ? "bg-card text-foreground shadow-card"
                                : "text-muted-foreground hover:text-foreground"}`}
                        >
                            <i className={op.icon} />
                            {op.label}
                        </button>
                    ))}
                </div>

                {aba === "dl" && <GerarComissaoDL ano={ano} mes={mes} onGerado={aoGerarDL} />}

                {/* CARD DA */}
                {aba === "da" && <div className="max-w-3xl rounded-2xl border border-border bg-card p-6 shadow-card flex flex-col gap-5">
                    <div className="flex items-center gap-3">
                        <div className="w-9 h-9 rounded-lg bg-green-50 flex items-center justify-center flex-shrink-0">
                            <i className="fa fa-warehouse text-green-600" />
                        </div>
                        <div>
                            <h2 className="font-semibold text-sm text-foreground leading-tight font-display">
                                Distribuidor Autorizado — Caxias
                            </h2>
                            <p className="text-xs text-muted-foreground">Motoristas e auxiliares DA</p>
                        </div>
                    </div>

                    <label className="flex cursor-pointer items-start gap-2 rounded-lg border border-border bg-muted px-3 py-2 text-xs">
                        <input
                            type="checkbox"
                            className="mt-0.5"
                            checked={atualizarTelemetria}
                            onChange={e => setAtualizarTelemetria(e.target.checked)}
                            disabled={isBlocked}
                        />
                        <span>
                            <span className="font-semibold text-foreground">Atualizar telemetria (Concept) antes de gerar</span>
                            <br />
                            <span className="text-muted-foreground">
                                Desmarque para usar os avisos de velocidade já importados e gerar mais rápido.
                            </span>
                        </span>
                    </label>

                    <div className="space-y-2">
                        {renderSteps(passosDA, etapaDA)}
                    </div>

                    {etapaDA === "ok" && (
                        <div className="flex items-center gap-2 text-xs text-success bg-success/10 border border-success/30 rounded-lg px-3 py-2">
                            <i className="fa fa-check-circle text-success" />
                            Comissões DA geradas com sucesso
                        </div>
                    )}

                    {etapaDA === "erro" && (
                        <div className="flex items-center gap-2 text-xs text-destructive bg-destructive/10 border border-destructive/30 rounded-lg px-3 py-2">
                            <i className="fa fa-exclamation-circle text-destructive" />
                            Erro ao gerar. Tente novamente.
                        </div>
                    )}

                    <div className="flex gap-2 mt-auto">
                        <Button
                            variant="green"
                            label={loadingDA ? "Gerando..." : "Gerar Comissão York Caxias"}
                            iconLeft={loadingDA ? "fa fa-spinner fa-spin" : "fa fa-warehouse"}
                            loading={loadingDA}
                            onClick={gerarDA}
                            disabled={isBlocked}
                        />

                        <Button
                            variant="outline"
                            label="Feriados"
                            iconLeft="fa fa-calendar-times"
                            onClick={() => setModalFeriados(true)}
                            disabled={isBlocked}
                        />

                        {etapaDA === "ok" && (
                            <>
                                <Button
                                    variant="outline"
                                    label="Enviar e-mail"
                                    iconLeft="fa fa-envelope"
                                    onClick={enviarEmailDA}
                                    disabled={isBlocked}
                                />
                                <Button
                                    variant="outline"
                                    iconLeft="fa fa-cog"
                                    onClick={() => setModalConfigEmail(true)}
                                    disabled={isBlocked}
                                />
                            </>
                        )}
                    </div>
                </div>}
                <FeriadosModal visible={modalFeriados} onHide={() => setModalFeriados(false)} anoInicial={ano} />

            <Dialog
                    header="Configurar envio de e-mails"
                    visible={modalConfigEmail}
                    onHide={() => setModalConfigEmail(false)}
                    className="w-[70%]"
                >
                    <div className="flex flex-column gap-2 w-full p-3">
                        <label style={{ fontWeight: 500 }}>
                            Destinatários
                        </label>

                        <Chips
                            value={destinatarios}
                            onChange={(e) => setDestinatarios(e.value)}
                            placeholder="Digite o e-mail e pressione Enter"
                            separator=","
                            className="min-w-full"
                        />

                        <small className="text-muted-foreground">
                            Você pode adicionar múltiplos e-mails pressionando Enter ou vírgula.
                        </small>
                    </div>
                </Dialog>
            </div>

            {/* Parciais já geradas: a geração geral as preserva e paga só os dias restantes */}
            <div className="mt-6">
                <ComissoesParciaisBloqueadas ano={ano} mes={mes} refreshKey={refreshBloqueadas} onAlterado={onGerado} />
            </div>
        </motion.div>
    );
}
